import cx from 'classnames'
import styles from './favourite-cta.module.css'
import { HeartIcon } from './icon/heart-icon'

export interface FavouriteCTAProps {
  isPending: boolean
  isSaved: boolean
  onClick: () => void
}

const FavouriteCTA = ({ isPending, isSaved, onClick }: FavouriteCTAProps) => {
  const FAVOURITE_CAR = 'Add car to favourites'
  const UNFAVOURITE_CAR = 'Remove car from favourites'
  const favouriteIconName = isSaved ? 'Filled' : 'Outline'

  return (
    <button
      type="button"
      aria-label={isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR}
      onClick={onClick}
      className={cx(styles['favouriteCta'], {
        [styles['favouriteCtaPending']]: isPending,
        [styles['favouriteCtaSaved']]: isSaved,
      })}
    >
      <HeartIcon name={favouriteIconName} size={16} />
      Favourite
    </button>
  )
}

export default FavouriteCTA
